import React from "react";
import { dbfileSize } from "../../actions";
import JPG from "../../build/images/jpg-file.png";
import XLS from "../../build/images/media-icon.png";
import PDF from "../../build/images/pdf-file.png";
import MP3 from "../../build/images/mp3-file.png";
import AVI from "../../build/images/avi-file.png";
import "./style.css";
import Moment from "moment";

const { connection_platform } = require("../../services/api");
const { meses } = require("../../services/data");

var dia = "";
var auxdia = "";
var mes = "";
var ano = "";
var loading = false;
var array = [];
var testearm = [];

var gethostname = window.location.hostname;
var pathname = "";

var iplocal = connection_platform.ip_intern;
var port = connection_platform.port_backend_intern;

if (gethostname === "localhost") pathname = iplocal;
else pathname = gethostname;

var ipcurrent = pathname;

if (pathname !== connection_platform.ip_intern) {
  ipcurrent = connection_platform.ip_apache_view_extern;
  // if(parseInt(connection_platform.port_apache_view_extern) !== 80){
  ipcurrent = ipcurrent + ":" + connection_platform.port_apache_view_extern;
  //}
} else {
  ipcurrent = connection_platform.ip_apache_view_intern;
  //if(parseInt(connection_platform.port_apache_view_intern) !== 80){
  ipcurrent = ipcurrent + ":" + connection_platform.port_apache_view_intern;
  //}
}

function isJson(item) {
  item = typeof item !== "string" ? JSON.stringify(item) : item;

  try {
    item = JSON.parse(item);
  } catch (e) {
    return false;
  }

  if (typeof item === "object" && item !== null) {
    return true;
  }

  return false;
}

function createJSON(item) {
  // mensagem_tratada = item.replace(/¿/gi, "\n");
  var mensagem_tratada = item;
  // mensagem_tratada = mensagem_tratada.replace(/§/gi, "\r\n");
  let valor = 1;
  try {
    mensagem_tratada =
      '{"' + valor + '": [{"mensagem_tratada":"' + mensagem_tratada + '"}]}';
    var obj = JSON.parse(mensagem_tratada);
    mensagem_tratada = obj[1][0].mensagem_tratada;
  } catch (e) {
    mensagem_tratada = item;
  }
  return mensagem_tratada;
}

export default function PdfDocument(props) {
  array = props.history;
  let cliente = props.cliente;
  let datapdfinit = props.datapdfinit;
  let datapdfend = props.datapdfend;
  let numero = props.numero;
  return (
    <div className="hist-atd__channel-chat active pdf-export">
      <div>
        <span>Histórico de atendimentos</span>
        <br />
        <span>
          {createJSON(cliente)} - {numero}
        </span>
        <br />
        {/* <span>Data: {Moment(datapdfinit, 'YYYY-MM-DDT00:00').format('DD/MM/YYYY 00:00')} até {Moment(datapdfend, 'YYYY-MM-DDT00:00').format('DD/MM/YYYY 23:59')}</span> */}
      </div>
      {array.map((history) => (
        <div
          key={history.id}
          className={history.agente === true ? "message right" : "message left"}
        >
          {(() => {
            dia = history.diaenvio;
            mes = history.mesenvio;
            ano = history.anoenvio;
            mes = meses.indexOf(mes);
            dia = dia + " de " + meses[mes - 1];
            if (ano < history.anoenvio || ano > history.anoenvio)
              dia = dia + " de " + history.anoenvio;
            if (dia !== auxdia) {
              dia = dia;
              auxdia = dia;
            } else {
              auxdia = dia;
              dia = "";
            }
          })()}
          <div id={history.id} className="time">
            {dia}
          </div>
          <div className="bubble">
            <div className="bubble-user-name">
              {history.agente === false
                ? createJSON(cliente)
                : history.username}
            </div>
            <div className="text">
              {(() => {
                let caption = history.caption;
                if (caption == "null" || caption == null) {
                  caption = "";
                } else {
                  caption = caption.replace(/\\n/g, "\r\n");
                }
                var positmessage1 = "";
                var positmessage2 = "";
                if (history.is_from_agent === true) {
                  positmessage1 = " right";
                }
                if (history.mimetypeid == "1") {
                  var msg = history.messagem;
                  msg = msg.replace(/\\\\n/gi, "\r\n");
                  return (
                    <div>
                      {msg}
                      <span className="text__end-spacing"></span>
                    </div>
                  );
                } else {
                  if (history.mimetypeid == "2") {
                    if (isJson(history.messagem) === true) {
                      let json = JSON.parse(history.messagem);
                      let options = json.options;
                      let i = 1;
                      var opcoes = [];
                      for (i in options) {
                        opcoes.push(i + " - " + options[i][1]);
                      }
                      return (
                        <div>
                          {json.msg + " \r\n "}
                          {opcoes.join("  \r\n  ")}
                          <span className="text__end-spacing"></span>
                        </div>
                      );
                    } else {
                      return (
                        <div>
                          {history.messagem}
                          <span className="text__end-spacing"></span>
                        </div>
                      );
                    }
                  } else if (history.mimetypeid == "30") {
                    if (isJson(history.messagem) === true) {
                      let json = JSON.parse(history.messagem);
                      let options = json.options;
                      let i = 1;
                      var opcoes = [];
                      for (i in options) {
                        opcoes.push(i + " - " + options[i][1]);
                      }
                      if (json.MSG) {
                        return (
                          <div>
                            {json.MSG + " \r\n "}
                            {opcoes.join("  \r\n  ")}
                            <span className="text__end-spacing"></span>
                          </div>
                        );
                      } else if (json.URL) {
                        return (
                          <div>
                            {json.URL + " \r\n "}
                            {opcoes.join("  \r\n  ")}
                            <span className="text__end-spacing"></span>
                          </div>
                        );
                      }
                    }
                  } else if (
                    history.mimetypeid == "3" ||
                    history.mimetypeid == "4" ||
                    history.mimetypeid == "5" ||
                    history.mimetypeid >= "6"
                  ) {
                    let separador = history.messagem.split(".");
                    switch (separador[1]) {
                      case "jpeg":
                      case "png":
                      case "PNG":
                      case "jpg":
                        return (
                          <div className="bubble-media">
                            {/* <div className="bubble-media__image" onClick={e => this.VerifierImage(e, connection_platform.type_connect+'://'+ipcurrent+history.messagem,'history')}>
                                                                                <img src={connection_platform.type_connect+'://'+ipcurrent+history.messagem} alt="" />
                                                                            </div>
                                                                            <div className="bubble-media__mediaInfo">
                                                                                <span className="bubble-media__fileType">
                                                                                <img className="bubble-media__fileIcon" src={JPG} alt="" />
                                                                                </span>
                                                                                <span className="bubble-media__fileName">
                                                                                <p className="bubble-media__text">Nome do Arquivo</p><br />
                                                                            <div className="fileinfo__bar">
                                                                                    <span className="fileinfo__size">{dbfileSize(history.filesize)}</span> • <span className="fileinfo__type">{''}</span>
                                                                            </div> 
                                                                                </span>
                                                                                <div className="bubble-media__download">
                                                                                    <a href={connection_platform.type_connect+'://'+ipcurrent+history.messagem} target="_blank" download className="bubble-media__btnDownload">
                                                                                        <i className="material-icons">get_app</i>
                                                                                    </a>
                                                                                </div>
                                                                        </div> */}
                            <img
                              src={
                                connection_platform.type_connect +
                                "://" +
                                ipcurrent +
                                history.messagem
                              }
                              alt=""
                              style={{ maxWidth: "400px", maxHeight: "500px" }}
                            />
                          </div>
                        );
                        break;
                      case "pdf":
                        return (
                          <div className="bubble-media">
                            <div className="bubble-media__mediaInfo">
                              <span className="bubble-media__fileType">
                                <img
                                  className="bubble-media__fileIcon"
                                  src={PDF}
                                  alt=""
                                />
                              </span>
                              <span className="bubble-media__fileName">
                                <p className="bubble-media__text">
                                  Nome do Arquivo
                                </p>
                                <br />
                                <div className="fileinfo__bar">
                                  <span className="fileinfo__size">
                                    {dbfileSize(history.filesize)}
                                  </span>{" "}
                                  • <span className="fileinfo__type">{""}</span>
                                </div>
                              </span>
                              <div className="bubble-media__download">
                                <a
                                  href={
                                    connection_platform.type_connect +
                                    "://" +
                                    ipcurrent +
                                    history.messagem
                                  }
                                  target="_blank"
                                  download
                                  className="bubble-media__btnDownload"
                                >
                                  <i className="material-icons">get_app</i>
                                </a>
                              </div>
                            </div>
                          </div>
                        );
                        break;
                      case "xls":
                      case "xlsx":
                      case "xlsm":
                      case "doc":
                      case "docx":
                      case "ppt":
                      case "pptx":
                        return (
                          <div className="bubble-media">
                            <div className="bubble-media__mediaInfo">
                              <span className="bubble-media__fileType">
                                <img
                                  className="bubble-media__fileIcon"
                                  src={XLS}
                                  alt=""
                                />
                              </span>
                              <span className="bubble-media__fileName">
                                <p className="bubble-media__text">
                                  Nome do Arquivo
                                </p>
                                <br />
                                <div className="fileinfo__bar">
                                  <span className="fileinfo__size">
                                    {dbfileSize(history.filesize)}
                                  </span>{" "}
                                  • <span className="fileinfo__type">{""}</span>
                                </div>
                              </span>
                              <div className="bubble-media__download">
                                <a
                                  href={
                                    connection_platform.type_connect +
                                    "://" +
                                    ipcurrent +
                                    history.messagem
                                  }
                                  target="_blank"
                                  download
                                  className="bubble-media__btnDownload"
                                >
                                  <i className="material-icons">get_app</i>
                                </a>
                              </div>
                            </div>
                          </div>
                        );
                        break;
                      case "wav":
                      case "mp3":
                      case "ogg":
                      case "mpeg":
                        return (
                          <div className="bubble-media">
                            <div className="bubble-media__playerBar">
                              <audio controls>
                                <source
                                  src={
                                    connection_platform.type_connect +
                                    "://" +
                                    ipcurrent +
                                    history.messagem
                                  }
                                  type="audio/ogg"
                                />
                                <source
                                  src={
                                    connection_platform.type_connect +
                                    "://" +
                                    ipcurrent +
                                    history.messagem
                                  }
                                  type="audio/mpeg"
                                />
                                Your browser.
                              </audio>
                            </div>
                            <div className="bubble-media__mediaInfo">
                              <span className="bubble-media__fileType">
                                <img
                                  className="bubble-media__fileIcon"
                                  src={MP3}
                                  alt=""
                                />
                              </span>
                              <span className="bubble-media__fileName">
                                <p className="bubble-media__text">
                                  Nome do Arquivo
                                </p>
                                <br />
                                <div className="fileinfo__bar">
                                  <span className="fileinfo__size">
                                    {dbfileSize(history.filesize)}
                                  </span>{" "}
                                  • <span className="fileinfo__type">{""}</span>
                                </div>
                              </span>
                              <div className="bubble-media__download">
                                <a
                                  href={
                                    connection_platform.type_connect +
                                    "://" +
                                    ipcurrent +
                                    history.messagem
                                  }
                                  target="_blank"
                                  download
                                  className="bubble-media__btnDownload"
                                >
                                  <i className="material-icons">get_app</i>
                                </a>
                              </div>
                            </div>
                          </div>
                        );
                        break;
                      case "mp4":
                        return (
                          <div className="bubble-media">
                            <div className="bubble-media__video">
                              <video
                                className="bubble-media__video-frame"
                                controls
                              >
                                <source
                                  className="bubble-media__video-file"
                                  src={
                                    connection_platform.type_connect +
                                    "://" +
                                    ipcurrent +
                                    history.messagem
                                  }
                                  type="video/mp4"
                                />
                                Seu navegador nao suporta esse tipo de arquivo.
                              </video>
                            </div>
                            <div className="bubble-media__mediaInfo">
                              <span className="bubble-media__fileType">
                                <img
                                  className="bubble-media__fileIcon"
                                  src={AVI}
                                  alt=""
                                />
                              </span>
                              <span className="bubble-media__fileName">
                                <p className="bubble-media__text">
                                  Nome do Arquivo
                                </p>
                                <br />
                                <div className="fileinfo__bar">
                                  <span className="fileinfo__size">
                                    {dbfileSize(history.filesize)}
                                  </span>{" "}
                                  • <span className="fileinfo__type">{""}</span>
                                </div>
                              </span>
                              <div className="bubble-media__download">
                                <a
                                  href={
                                    connection_platform.type_connect +
                                    "://" +
                                    ipcurrent +
                                    history.messagem
                                  }
                                  target="_blank"
                                  download
                                  className="bubble-media__btnDownload"
                                >
                                  <i className="material-icons">get_app</i>
                                </a>
                              </div>
                            </div>
                          </div>
                        );
                        break;
                      default:
                    }
                  }
                }
              })()}
            </div>
            <div className="text">
              {(() => {
                let caption = history.caption;
                if (caption == "null" || caption == null) {
                  caption = "";
                } else {
                  caption = caption.replace(/\\n/g, "\r\n");
                }
                return caption;
              })()}
            </div>
            <div className="bubble__info-content">
              <div className="fav fav--inside fav--right">
                {/* <i className="material-icons fav-icon">star_border</i> */}
              </div>
              <div className="bubble__info-content__time">
                {history.horaenvio}
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
